module.exports = __webpack_public_path__ + "media/bootstrap-icons/moisture-f966eb36.svg";